 $(function() {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/kiitos-kielipalvelut/"
    };

    $("#languageServicesForm").on("submit", function(event) {
        event.preventDefault();
        if ($('#languageServicesForm')[0].checkValidity() && $('#languageServicesCheckbox').is(':checked')) {
            $("#languageServicesSendBtn").prop("disabled", true);
            $("#languageServicesSendBtn").css("background-color", "#6c757d");
            let email = $("#languageServicesEmail").val();
            let firstName = $("#languageServicesFirstName").val();
            let lastName = $("#languageServicesLastName").val();
            let phone = $("#languageServicesPhone").val();
            let message = $("#languageServicesMessage").val();
            let code = "";
            if ($('#languageServicesNewsLetterCheckbox').is(':checked')) {
                code = "newsletter";
            }
            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                additionalInformation: message,
                phoneNumber: phone,
                competitionName: "KielipalvelutTyollisyysalueet",
                uri: "/fi/tulkkaus/ajankohtaista/kuntamarkkinoilta-poimittua-te24-ja-koto24/",
                languageCode: language,
                code: code,
            };


            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function() {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function(err) {
                    console.error(err);
                    $("#languageServicesSendBtn").prop("disabled", false);
                    $("#languageServicesSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#languageServicesForm')[0].checkValidity();
        const checkboxChecked = $('#languageServicesCheckbox').is(':checked');

        if (formValid && checkboxChecked) {
            // Enable button and change color
            $("#languageServicesSendBtn").prop("disabled", false);
            $("#languageServicesSendBtn").css("background-color", "#28a745"); // Change to your desired color (e.g., green)
        } else {
            // Disable button and reset color
            $("#languageServicesSendBtn").prop("disabled", true);
            $("#languageServicesSendBtn").css({
                "background-color": "#6c757d", // Change to your disabled color (e.g., grey)
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger the button state change on input and checkbox changes
    $('#languageServicesForm input, #languageServicesCheckbox').on('input change', toggleSendButtonState);



    // Initial button state check
    toggleSendButtonState();
});

